module.exports = __webpack_public_path__ + "static/img/qixu_print.png";